export { BottomFixedHeader } from './BottomFixedHeader';
